import React from "react";
import ReactApexChart from "react-apexcharts";

export default function LineChart({ title, data }) {
  const state = {
    series: [
      {
        name: title,
        data: data,
      },
    ],
    options: {
      chart: {
        height: "100%",
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth", // Ensures the line is smooth
        colors: ["#407BFF"], // Set line color
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // Alternating row colors
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
  };

  return (
    <div className="w-full h-full py-4">
      {title}
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height="100%"
      />
    </div>
  );
}
